export const RFPPage = ({index, children, docWidth, docHeight, fontSize}) =>{
    return (
        <div className="rfp-page" style={{ width: `${docWidth}px`, height: `${docHeight}px`, fontSize: `${fontSize}px`}}>
            <div className='rfp-page-content-container'>
            {children}
            </div>
            <div className = 'rfp-page-number'>{index + 1}</div>
        </div>
    )
}